import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { PublicHeaderComponent } from './public-header.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule
    ],
    declarations: [PublicHeaderComponent],
    exports: [PublicHeaderComponent]
})
export class PublicHeaderModule { }
